import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core"
import { Router } from "@angular/router"
import { Subscription } from "rxjs"
import { InstitutionService } from "src/app/shared/services/institution.service"
import { ScreenService } from "src/app/shared/services/screen.service"
import { ThemeService, ThemeColor } from "src/app/shared/services/theme/theme.service"

@Component({
  selector: "app-index",
  template: ""
})
export class IndexComponent implements OnInit, OnDestroy {

  subscription: Subscription = new Subscription()

  constructor(
    private screenService: ScreenService,
    private router: Router,
    private institutionService: InstitutionService,
    private themeService: ThemeService
  ) { /* do nothing */ }

  ngOnInit(): void {
    this.subscription.add(
      this.screenService.isKiosk().subscribe(kiosk => {
        if (kiosk) {
          this.goToIdlePage()
        } else {
          this.goToHomePage()
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  public goToHomePage(): void {
    this.router.navigate(["home"])
  }

  public goToIdlePage(): void {
    this.router.navigate(["idle"])
  }
}
